export const TooltipData_OpenTrade = {
  creditor: 'Creditor',
  originator: 'Originator',
  unscheduledEtr: 'Un Scheduled Etr',
  paymentDiscount: 'Payment Discount',
  ccy: 'Currency',
  faceValue: 'Face Value',
  remainingValue: 'Remaining Value',
  vatIncluded: '	VAT included',
  invoiceDate: 'Invoice Date',
  expectedDate: '	Expected Date ',
  pod: 'PoD',
  attachPod: 'Attach PoD',
  invoiceNo: 'Invoice No',
  attachInvoice: 'Attach Invoice',
  loanTerms: 'c-ETR Loan Terms',
  debtor: 'Name',
  paymentTerms: 'Payment Terms',
  totalFaceValue: 'Total Face Value',
  noOfEtr: 'Number of ETR',
  months: 'Revolving Offer Month',
  description: 'Description',
  supportingDocument: 'Attach Supporting Document',
  monthlyDiscount: 'Monthly Discount Percentage',
  allowBuyOut: 'Allow Buy Out',
  buyOutDiscount: 'Buy Out Discount Percentage',
  friendlyName: 'Friendly Name',
  sellRate: 'c-ETR Sell Rate Percentage',
  bEtr: 'b-ETR',
  poDate: 'PO Date',
  poNumber: 'PO No',
  pofile: 'Attach PO',
  revolvingETR: 'Upload Revolving ETR invoice for',
  deliverNoA: 'Deliver NoA to',

  type: 'ETR Type',
  issued: 'Issued',
  ref: 'Reference',
  deposit: 'Deposit',
  edso: 'EDSO',
  unitPrice: 'Unit Price',
  docNo: 'Document Number',
  etrFile: 'Attach ETR',
  contract: 'Attach Contract',
  signedFile: 'Attach signed',
};
